/**
 * Persists the previous route name after a successful transition.
 *
 * @param {Router5.Router} router
 */

const previousRoutePlugin = (router) => ({
  onTransitionSuccess: (toState, fromState) => {
    router.previousRoute = fromState ? fromState.name : null;
  },
});

export { previousRoutePlugin as default };
